import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { TranslationProvider } from "../i18n/TranslationContext";
import Home from "../pages/Home/Home";
import ErrorPage from "../pages/Error/Error";
import PrivacyPolicy from "../pages/Legal/PrivacyPolicy";
import TermsConditions from "../pages/Legal/TermsConditions";
import ContactUs from "../pages/ContactUs/ContactUs";

export default function AppRoutes() {
  return (
    <TranslationProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </TranslationProvider>
  );
}